import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GenderacceptedListComponent } from './genderaccepted-list/genderaccepted-list.component';
import { GenderacceptedCreateComponent } from './genderaccepted-create/genderaccepted-create.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list',
        component: GenderacceptedListComponent,
        data: {
          title: "Gender Accepted List",
          breadcrumb: "Gender Accepted List"
        }
      },
      {
        path: 'create',
        component: GenderacceptedCreateComponent,
        data: {
          title: "Create Gender Accepted",
          breadcrumb: "Create Gender Accepted"
        }
      },
      {
        path: 'edit/:id',
        component: GenderacceptedCreateComponent,
        data: {
          title: "Edit Gender Accepted",
          breadcrumb: "Edit Gender Accepted"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class GenderacceptedRoutingModule { }
